import { SpintrTypes } from "src/typings";

function isAdministrator(appState: Spintr.AppState): boolean {
    return appState.profile.active.roles.includes("administrators");
}

export function isHubAdministrator(appState: Spintr.AppState): boolean {
    if (isAdministrator(appState)) {
        return true;
    }

    const privileges = appState.privileges.data || [];

    return privileges.some(
        (p: any) => p.value
                 && p.privilegeId === SpintrTypes.Privilege.IsQualityHubAdministrator);
}

export function canSeeListOverviewBar(appState: Spintr.AppState): boolean {
    if (isHubAdministrator(appState)) {
        return true;
    }

    return !!appState.profile.active.leadsOffice;
}

